export default {
  state: {
    recordsPerPage: {}
  },

  getters: {
    getThisTableRecordPerPage(state) {
      return tableId => {
        if (tableId) {
          if (state.recordsPerPage[tableId]) {
            return state.recordsPerPage[tableId];
          } else {
            return 25;
          }
        }
        return 25;
      };
    }
  },

  mutations: {
    setRecordPerPage(state, payload) {
      state.recordsPerPage[payload.tableId] = payload.perPageCount;
      state.recordsPerPage = { ...state.recordsPerPage };
    }
  },

  actions: {
    setRecordPerPage({ commit }, payload) {
      // payload is {tableId: ID, perPageCount: 25}
      if (payload && payload.tableId && payload.perPageCount) {
        commit("setRecordPerPage", payload);
      }
    }
  }
};
